import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeTrainingService } from './../../../../pages/employee/services/employeetraining.service';

@Component({
  selector: 'app-remove-class-modal',
  templateUrl: './remove-class-modal.component.html',
  styleUrls: ['./remove-class-modal.component.css']
})
export class RemoveClassModalComponent implements OnInit {
  @Input() classInfo: any;

  constructor(public activeModal: NgbActiveModal, private employeeTrainingService: EmployeeTrainingService) { }

  ngOnInit(): void {
  }

  
  deleteClicked() {
    this.employeeTrainingService.removeClass(this.classInfo.TrainingClassID).then((response: any) => {
      this.activeModal.close();
    });
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }
}
